import { render } from "./cell_tag-tag.vue?vue&type=template&id=1bdff457"
import script from "./cell_tag-tag.vue?vue&type=script&lang=ts"
export * from "./cell_tag-tag.vue?vue&type=script&lang=ts"

import "./cell_tag-tag.vue?vue&type=style&index=0&id=1bdff457&lang=less"
script.render = render

export default script